/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AssetClassificationUpdate = {
    readonly uuid?: string;
    label: string;
    level: AssetClassificationUpdate.level;
}

export namespace AssetClassificationUpdate {

    export enum level {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }


}
